"use client"

import React from "react"

interface PillFilterProps {
  label: string
  icon?: React.ReactNode
  active: boolean
  onClick: () => void
}

export default function PillFilter({ label, icon, active, onClick }: PillFilterProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm transition-colors focus:outline-none ${
        active
          ? "bg-blue-600 text-white ring-2 ring-blue-400/50"
          : "bg-gray-800 text-gray-300 hover:bg-gray-700"
      }`}
    >
      {icon}
      <span className="whitespace-nowrap">{label}</span>
    </button>
  )
}